import { getCountryName, getBrandCountries, getDefaultCountry, getMapCountrySite, getLanguageName, } from '../../countries';
import { getGlobalEData, getLocale, handleGlobalEBanner } from '../globalE';
export default async () => {
    const switchers = document.querySelectorAll('header [data-switch-redirect]');
    if (!switchers.length)
        return;
    const globalEData = getGlobalEData();
    const defaultCountry = getDefaultCountry();
    if (!globalEData || !defaultCountry)
        return;
    const countries = getBrandCountries();
    const countryData = countries.find((c) => c.label === globalEData.countryISO);
    const mapCountrySite = getMapCountrySite();
    const countrySite = mapCountrySite[globalEData.countryISO];
    const countryFromSite = countryData && countrySite && window.location.pathname.startsWith(`/${countrySite}`);
    // @ts-ignore
    const globalECountries = window.globalECountries || [];
    // Display country code + currency code (letters instead of symbols)
    let countryCode;
    let currencyCode;
    if (countryFromSite) {
        countryCode = countryData.label;
        currencyCode = globalECountries.includes(countryData.label)
            ? globalEData.currencyCode
            : countryData.currencyCode;
    }
    else {
        countryCode = defaultCountry.code;
        currencyCode = defaultCountry.currencyCode;
    }
    switchers.forEach(async (switcher) => {
        const countryNameEl = switcher.querySelector('[data-country-name]');
        if (countryNameEl) {
            countryNameEl.innerHTML = countryCode;
        }
        const currencyEl = switcher.querySelector('[data-currency]');
        if (currencyEl) {
            currencyEl.innerHTML = currencyCode;
        }
        // Switch action
        switcher.addEventListener('click', (e) => {
            e.stopPropagation();
            handleGlobalEBanner(true);
        });
        // Mobile country display
        const countryName = await getCountryName(countryCode);
        const countryNameMobileEl = switcher.querySelector('[data-country-name-mobile]');
        if (countryNameMobileEl) {
            countryNameMobileEl.innerHTML = countryName;
        }
        // Mobile language display
        const languageName = await getLanguageName(getLocale());
        const languageNameMobileEl = switcher.querySelector('[data-language-name-mobile]');
        if (languageNameMobileEl) {
            languageNameMobileEl.innerHTML = languageName;
        }
    });
};
